module.exports = __webpack_public_path__ + "img/background.60e71b2c.png";